import useRequest from '@swf/core/hooks/useRequest';

import { fetchToken } from './utils';

export const useRequestToken = () => {
  const request = useRequest();

  return async (isReverification: boolean) => {
    const response = await fetchToken(request, isReverification).toPromise();
    return response.body?.token;
  };
};
